<template>
  <div>
    <!-- <router-view></router-view> -->
    <v-header />
    <div class="t-nav">
      <ul>
        <li @click="showbook">
          <p :class="navId === 1 ? 'actived' : ''">原创书籍</p>
        </li>
        <li @click="showvideo">
          <p :class="navId === 2 ? 'actived' : ''">视频资料</p>
        </li>
      </ul>
    </div>
    <transition name="slide-fade">
      <div class="sub-teacher" v-if="isshow">
        <div class="card-bg">
          <div class="bookcard" v-for="(item, index) in bookList" :key="index">
            <div class="card-img">
              <img :src="item.imageUrl" alt="/" />
              <div class="set" v-if="item.type == 1">自研教材</div>
              <div class="set" v-else>系列丛书</div>
            </div>
            <div class="card-right">
              <p class="card-name">{{ item.title }}</p>
              <p class="card-txt">{{ item.summary }}</p>
              <div class="card-ve">
                <p>
                  作者：<span>{{ item.author }}</span>
                </p>
                <p>
                  出版社：<span>{{ item.publisher }}</span>
                </p>
              </div>
              <div class="pricing">
                定价：<span>{{ item.price }}</span
                ><span onclick="doyoo.util.openChat('g=10063915');return false;"
                  >咨询客服</span
                >
              </div>
            </div>
          </div>
          <div class="comment">以上书籍仅供浏览，如需购买请至各大销售机构</div>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div class="sub-teacher" v-if="!isshow">
        <div class="card-bg" v-for="(i, index) in coverList" :key="index">
          <div class="cover" v-show="coverList">
            <img :src="i.imageUrl" alt="/" />
            <p class="cover-title">{{ i.title }}</p>
            <div class="cover-txt">{{ i.summary }}</div>
          </div>
          <div class="cata-video">
            <div
              class="cata-item"
              v-for="ele in i.videoList"
              :key="ele.id"
              @click="playvideo(ele.id, ele.videoUrl)"
            >
              <div class="cata-left">
                <img src="/static/v_g.png" alt="" /><span>{{ ele.title }}</span>
              </div>
              <div class="cata-right">{{ ele.duration | dealTime }}</div>
            </div>
            <div class="checkall" v-if="i.videoshow" @click="loadall(i)">
              查看全部<sub>︾</sub>
            </div>
          </div>
        </div>
        <CourseVideo
          :url="url"
          v-if="isCourseVideo"
          @close="isCourseVideo = false"
        />
      </div>
    </transition>
  </div>
</template>
<script>
import VHeader from "./header/VHeader";
import CourseVideo from "./video/CourseVideo";

export default {
  metaInfo: {
    title: "自学资源_软件测试学习资料_博为峰51Testing软件测试培训官网",
    meta: [
      {
        name: "keywords",
        content: "软件测试学习资料,自学资源,博为峰51Testing,软件测试培训"
      },
      {
        name: "description",
        content:
          "博为峰51Testing自学资源，针对测试爱好者的自学需求，提供自研教材、软件测试系列丛书、软件测试视频课程等精品自学资料。"
      }
    ]
  },
  // JSON-LD 结构化数据
  script: [
    {
      vmid: "json_ld_course",
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "Webpage",
            "@id": "https://www.51testing.net/selflearning.html#webpage",
            name: "自学资源_软件测试学习资料_博为峰51Testing软件测试培训官网",
            description:
              "博为峰51Testing自学资源，针对测试爱好者的自学需求，提供自研教材、软件测试系列丛书、软件测试视频课程等精品自学资料。",
            url: "https://www.51testing.net/selflearning.html",
            inLanguage: "zh-CN",
            publisher: {
              "@id": "https://www.boweifeng.com/#organization"
            }
          }
        ]
      }),
      __dangerouslyDisableSanitizers: ["script"]
    }
  ],
  components: {
    VHeader,
    CourseVideo
  },
  data() {
    return {
      bookList: [],
      coverList: [],
      videoList: [],
      alllist: [],
      // count:4,
      navId: "",
      isshow: true,
      videoshow: true,
      // timeStr: '',
      url: "",
      isCourseVideo: false,
      time: 0
    };
  },
  // watch: {
  //   navId: {
  //     handler() {
  //       this.showbook();
  //     },
  //     immediate: true
  //   }
  // },
  mounted() {
    this.navId = 1;
    this.getList();
  },
  methods: {
    showbook() {
      this.navId = 1;
      this.isshow = true;
      this.getList();
    },
    showvideo() {
      this.navId = 2;
      this.isshow = false;
      this.getList2();
    },
    getList() {
      this.axios.get("/api/consume/bookinfo").then(res => {
        this.bookList = res.data;
      });
    },
    getList2() {
      this.axios.get("/api/consume/VideoIntroduce").then(res => {
        console.log(res.data);
        this.coverList = res.data;
        this.coverList.forEach((val, i) => {
          val.alllist = res.data[i].videoList;
          val.videoshow = true;
          val.videoList = res.data[i].videoList.slice(0, 5);
        });
        // this.alllist = res.data[0].videoList;
        // this.videoList = res.data[0].videoList.slice(0,5);
        // this.coverList[0].videoList.forEach((val,i,arr) => {
        //   console.log( this.coverList[0].videoList)
        //   this.time = val.duration;
        //   val = this.dealTime(this.time);
        // })
      });
    },
    loadall(val) {
      val.videoList = val.alllist;
      val.videoshow = false;
    },
    playvideo(id, videoUrl) {
      this.isCourseVideo = true;
      this.url = videoUrl;
    }
  },
  filters: {
    dealTime(time) {
      // timeFormat = (time) => {
      let timeStr = "";
      let stringFormat = i => {
        return i < 10 ? `0${i}` : `${i}`;
      };
      let minuteTime = 0;
      let secondTime = 0;
      let hourTime = 0;
      // console.log(time)
      if (time < 60) {
        timeStr = `00:00:${stringFormat(time)}`;
      } else if (time >= 60 && time < 3600) {
        minuteTime = parseInt(time / 60);
        secondTime = parseInt(time % 60);
        timeStr = `00:${stringFormat(minuteTime)}:${stringFormat(secondTime)}`;
      } else if (time >= 3600) {
        let _t = parseInt(time % 3600);
        hourTime = parseInt(time / 3600);
        minuteTime = parseInt(_t / 60);
        secondTime = parseInt(_t % 60);
        timeStr = `${stringFormat(hourTime)}:${stringFormat(
          minuteTime
        )}:${stringFormat(secondTime)}`;
      }
      return timeStr;
      // }
    }
  }
};
</script>
<style scoped>
.t-nav {
  height: 97px;
}
.t-nav ul {
  overflow: hidden;
}
.t-nav ul li {
  float: left;
  width: 50%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  font-size: 28px;
  color: #282828;
  padding: 30px 0;
}
.t-nav ul li p {
  width: 170px;
  margin: 0px auto;
}
.actived {
  background: #0084ff !important;
  color: #ffffff !important;
  border-radius: 50px;
}
.sub-teacher {
  background: #f4f4f4;
  height: auto;
  padding: 20px 30px;
  padding-top: 20px;
  overflow: hidden;
}
.clearfix {
  clear: both;
}
.card-bg {
  background: #fff;
  padding: 20px 20px 36px 20px;
}
.bookcard {
  overflow: hidden;
  padding-bottom: 30px;
  margin-top: 20px;
  border-bottom: 1px solid rgb(159, 164, 175);
  position: relative;
}
.bookcard:last-child {
  border-bottom: none;
}
.bookcard .card-img {
  width: 234px;
  height: 284px;
  float: left;
  margin-right: 22px;
  position: relative;
}
.card-img > img {
  width: 234px;
  height: 284px;
}
.card-img .set {
  width: 114px;
  height: 34px;
  font-size: 16px;
  line-height: 34px;
  text-align: center;
  color: #fff;
  background: #e60012;
  position: absolute;
  right: 0;
  top: 15px;
}
.bookcard .card-right {
  float: left;
  text-align: left;
  width: 390px;
}
.bookcard .card-name {
  font-size: 26px;
  color: rgb(68, 68, 68);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 10px;
}
.bookcard .card-txt {
  font-size: 16px;
  color: rgb(159, 164, 175);
  margin-top: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.bookcard .card-ve {
  margin-top: 20px;
  font-size: 18px;
  color: rgb(139, 139, 139);
}
.bookcard .pricing {
  margin-top: 22px;
  font-size: 20px;
  color: rgb(103, 103, 103);
}
.bookcard .pricing > span:nth-child(1) {
  color: rgb(240, 62, 62);
}
.bookcard .pricing > span:nth-child(2) {
  color: rgb(91, 137, 253);
  margin-left: 26px;
  position: relative;
}
.bookcard .pricing > span:nth-child(2)::before {
  content: "";
  width: 2px;
  height: 24px;
  background: rgb(159, 164, 175);
  position: absolute;
  left: -10px;
  top: 3px;
}
.card-bg .comment {
  font-size: 14px;
  color: #ccc;
  text-align: left;
  margin-top: 14px;
}
.cover {
  padding-bottom: 20px;
  border-bottom: 1px solid #9fa4af;
}
.cover > img {
  width: 650px;
  height: 366px;
}
.cover .cover-title {
  font-weight: bold;
  font-size: 30px;
  color: #444;
  text-align: left;
  margin-top: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.cover .cover-txt {
  margin-top: 20px;
  font-size: 18px;
  color: #9fa4af;
  text-align: left;
  line-height: 30px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.cata-item {
  width: 100%;
  height: 68px;
  font-size: 20px;
  color: #676767;
  overflow: hidden;
  border-bottom: 1px solid #9fa4af;
}
.cata-item .cata-left {
  float: left;
  margin-top: 20px;
}
.cata-item .cata-left > img {
  width: 24px;
  height: 24px;
}
.cata-item .cata-left > span {
  width: 490px;
  margin-left: 20px;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.cata-item .cata-right {
  line-height: 68px;
  float: right;
}
.cata-video .checkall {
  text-align: center;
  font-size: 20px;
  color: #676767;
  margin-top: 10px;
}
.card-bg sub {
  margin-left: 8px;
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(530px);
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/SelfLearning.vue